import React from 'react'
import Header from './ui/Header'
import { useLocation } from 'react-router-dom'
import Appereance from './ui/Appereance'
import { Sprite } from '@/components/Sprite'
import { ThemeProvider } from '@/components/ThemeProvider'

interface LayoutProps {
  children: React.ReactNode
  className?: string
}

const Layout = (props: LayoutProps) => {
  const location = useLocation()
  const { pathname } = location
  const hideBurgerCondition =
    pathname.startsWith('/email') ||
    pathname.startsWith('/paywall') ||
    pathname.startsWith('/thank-you')
  const isDesktopPage =
    pathname.startsWith('/terms-of-use') || pathname.startsWith('/privacy-policy')
  return (
    <ThemeProvider>
      <Sprite />
      {isDesktopPage ? (
        <>
          <Header hideBurger desktop />
          <main className="max-w-desktop w-full mx-auto box-border overflow-x-visible">
            {props.children}
          </main>
        </>
      ) : (
        <Appereance>
          {pathname && pathname !== '/scan-results' && <Header hideBurger={hideBurgerCondition} />}
          <div
            className={`${props.className ? props.className + ' ' : ''}w-full flex flex-col relative`}
          >
            <main
              className={`${pathname.includes('/intro') ? 'intro-main' : ''} max-w-content ${!pathname.includes('/thank-you') ? 'px-4' : ''} w-full mx-auto box-border overflow-x-visible`}
            >
              {props.children}
            </main>
          </div>
        </Appereance>
      )}
    </ThemeProvider>
  )
}

export default Layout
